const translateHeader = {
    en: {
        sound: "Sound",
        music: "Music",
        animation: "Animation",
        freeBets: "Free Bets",
        myBetHistory: "My Bet History",
        gameLimits: "Game Limits",
        howToPlay: "How To Play",
        gameRules: "Game Rules",
        provablyFairSettings: "Provably Fair Settings",
        change: "Change",
        avatar: "Avatar",
        minimumBetUsd: "Minimum bet",
        maximumBetUsd: "Maximum bet",
        maximumWin: "Maximum win for one bet",
        gameLimitsUsd: "USD:",
    },
    ru: {
        sound: "Звук",
        music: "Музыка",
        animation: "Анимация",
        freeBets: "Бесплатные ставки",
        myBetHistory: "История моих ставок",
        gameLimits: "Ограничения игры",
        howToPlay: "Как играть",
        gameRules: "Правила игры",
        provablyFairSettings: "Настройки Provably Fair",
        change: "Изменить",
        avatar: "Аватар",
        minimumBetUsd: "Минимальная ставка",
        maximumBetUsd: "Максимальная ставка",
        maximumWin: "Максимальный выигрыш за одну ставку",
        gameLimitsUsd: "USD:",
    },
    uz: {
        sound: "Ovoz",
        music: "Musiqa",
        animation: "Animatsiya",
        freeBets: "Bepul pul tikishlar",
        myBetHistory: "Mening pul tikish tarixim",
        gameLimits: "O'yin cheklovlari",
        howToPlay: "Qanday o'ynaladi",
        gameRules: "O'yin qoidalari",
        provablyFairSettings: "Adolatli sozlamalar",
        change: "O'zgartirish",
        avatar: "Profil rasmi",
        minimumBetUsd: "Minimal pul tikish",
        maximumBetUsd: "Maksimal pul tikish",
        maximumWin: "Bir pul tikish uchun maksimal yutuq",
        gameLimitsUsd: "USD:",
    }
}

export default translateHeader;